import React, { useEffect, useState } from 'react';
import { Badge, Button, Card, Modal, Spinner } from 'react-bootstrap';
import { IoCloseOutline, IoCopyOutline, IoCreateOutline, IoServerOutline, IoTimeOutline } from 'react-icons/io5';
import AuditHistoryModal from './AuditHistoryModal';
import ViewDataSetModal from './ViewDataSetModal';
import { getAuditHistoryApi, getDataSetApi } from '../narrativeReportsApi';
import { useTranslation } from 'react-i18next';

const titleByFramework = {
  TCFD: 'TCFD Report Generator',
  SECR: 'SECR Report Generator',
  CSRD: 'CSRD Report Generator',
};

const ViewReportModal = ({ show, report, onClose, onEdit, onClone, isLoading, orgId }) => {
  const { t } = useTranslation();
  const [showDataSet, setShowDataSet] = useState(false);
  const [showAudit, setShowAudit] = useState(false);
  const [auditHistory, setAuditHistory] = useState(null);
  const [dataset, setDataset] = useState(null);

  useEffect(() => {
    setAuditHistory(null);
    setDataset(null);
  }, [report?.id]);

  const handleShowDataSet = () => {
    setShowDataSet(true);
    if (!dataset && report) {
      getDataSetApi(orgId, report.id).then((res) => setDataset(res.data ?? []));
    }
  };

  const handleShowAudit = () => {
    setShowAudit(true);
    if (!auditHistory && report) {
      getAuditHistoryApi(orgId, report.id).then((res) => setAuditHistory(res.data ?? []));
    }
  };

  return (
    <>
      <Modal show={show && !showDataSet && !showAudit} onHide={onClose} size="xl" centered dialogClassName="narrative-view-modal">
        <Modal.Header className="narrative-modal-header">
          <div>
            <Modal.Title className="text-primary">{report ? (titleByFramework[report.framework] || t('Narrative Disclosure Generator')) : ''}</Modal.Title>
            <div className="text-muted">{report?.name}</div>
            <Badge variant="primary" className="mt-2">{t('Read-Only View')}</Badge>
          </div>
          <div className="d-flex align-items-center">
            <Button variant="outline-secondary" className="mr-2" onClick={handleShowDataSet} disabled={!report}>
              <IoServerOutline className="mr-1" />
              {t('Data Set')}
            </Button>
            <Button variant="outline-secondary" className="mr-2" onClick={handleShowAudit} disabled={!report}>
              <IoTimeOutline className="mr-1" />
              {t('Audit History')}
            </Button>
            {report?.status === 'completed' ? (
              <Button variant="outline-secondary" className="mr-2" onClick={onClone} disabled={!report}>
                <IoCopyOutline className="mr-1" />
                {t('Clone')}
              </Button>
            ) : (
              <Button variant="outline-secondary" className="mr-2" onClick={() => onEdit()} disabled={!report}>
                <IoCreateOutline className="mr-1" />
                {t('Edit')}
              </Button>
            )}
            <Button variant="link" onClick={onClose}><IoCloseOutline size={24} /></Button>
          </div>
        </Modal.Header>
        <Modal.Body className="narrative-modal-body">
          {isLoading || !report ? (
            <div className="text-center p-5"><Spinner animation="border" /></div>
          ) : (
            <Card className="mx-auto narrative-modal-document">
              <Card.Body>
                <div className="narrative-preview" dangerouslySetInnerHTML={{ __html: report.narrative || '' }} />
              </Card.Body>
            </Card>
          )}
        </Modal.Body>
      </Modal>
      <ViewDataSetModal show={showDataSet} onClose={() => setShowDataSet(false)} dataset={dataset} />
      <AuditHistoryModal
        show={showAudit}
        onClose={() => setShowAudit(false)}
        onRestoreVersion={(version) => {
          setShowAudit(false);
          onEdit(version);
        }}
        reportName={report?.name}
        reportStatus={report?.status}
        auditHistory={auditHistory}
      />
    </>
  );
};

export default ViewReportModal;
